import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Context } from "../../Context/ContextApi";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { clearCart } from "./../../Redux/CartSlice"; // Make sure clearCart is in cartSlice

const CheckoutPage = () => {
  const { getAddress, addresses, handleAddAddress } = useContext(Context);
  const cartItems = useSelector((state) => state.cartSlice.cartItems);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    temp_name: "",
    temp_mobile: "",
    locality: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
    address_type: "",
  });

  const [selectAddress, setSelectAddress] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  useEffect(() => {
    getAddress();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmitOrder = () => {
    if (!selectAddress) {
      toast.error("Please select an address!");
      return;
    }
    
    // Check if the cart is empty (a safeguard)
    if (cartItems.length === 0) {
      toast.error("Your cart is empty. Please add items before checking out.");
      return;
    }

    const id = toast.loading("Placing your order...");

    // ✅ CORRECTION HERE: Include size and print options in the payload
    const formattedProducts = cartItems.map((item) => ({
      product_id: item.id,
      qty: item.quantity,
      price: parseFloat(item.price),
      total_price: parseFloat(item.price) * item.quantity,
      // Pass size and print options to the backend
      size: item.size || "Default", 
      print_on: item.print || "Not Selected", 
    }));

    const data = {
      address_id: selectAddress,
      cart_price: formattedProducts.reduce(
        (acc, item) => acc + item.total_price,
        0
      ),
      delivery_charge: 0,
      coupon_code: "",
      coupon_amount: 0,
      total_price: formattedProducts.reduce(
        (acc, item) => acc + item.total_price,
        0
      ),
      payment_method: "cod",
      payment_id: "",
      product: formattedProducts,
    };

    axios
      .post("https://admin.tulikaarts.in/api/generate-order", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        toast.success("Order placed successfully!", { id });

        // Clear the cart
        dispatch(clearCart());

        // Redirect to Thank You page with order data
        navigate("/thankyou", { state: { orderDetails: res.data } });
      })
      .catch((err) => {
        toast.error("Failed to place order", { id });
        console.log(err);
      });
  };

  return (
    <div className="container my-5">
      <h1 className="text-center fw-bold mb-5">Checkout</h1>
      <div className="row">
        {/* Shipping / Address Section */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3>Shipping Information</h3>
            <button
              className="btn btn-dark"
              onClick={() => setShowModal(true)}
            >
              + Add Address
            </button>
          </div>

          {addresses.length > 0 ? (
            addresses.map((item) => (
              <div
                key={item.id}
                className={`card p-3 mb-3 d-flex align-items-start ${
                  selectAddress === item.id ? "border-success border-3 shadow-sm" : ""
                }`}
                style={{ position: "relative" }}
              >
                <input
                  type="radio"
                  name="selectedAddress"
                  value={item.id}
                  checked={selectAddress === item.id}
                  onChange={() => setSelectAddress(item.id)}
                  style={{
                    width: "20px",
                    height: "20px",
                    position: "absolute",
                    top: "15px",
                    left: "15px",
                    cursor: "pointer",
                  }}
                />
                <div style={{ marginLeft: "50px" }}>
                  <p className="mb-1">
                    <strong>Name:</strong> {item.temp_name}
                  </p>
                  <p className="mb-1">
                    <strong>Address:</strong> {item.locality}, {item.city},{" "}
                    {item.state}, {item.country}
                  </p>
                  <p className="mb-1">
                    <strong>Pincode:</strong> {item.pincode}
                  </p>
                  <p className="mb-1">
                    <strong>Mobile:</strong> {item.temp_mobile}
                  </p>
                  <span className="badge bg-secondary">
                    {item.address_type}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted">No saved addresses found. Please add one to proceed.</p>
          )}

          {/* Add Address Modal - Only show the JSX if showModal is true */}
          {showModal && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              style={{
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => setShowModal(false)} // Close modal on outside click
            >
              <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}> 
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add New Address</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row g-2">
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Name"
                          name="temp_name"
                          value={formData.temp_name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Mobile Number"
                          name="temp_mobile"
                          value={formData.temp_mobile}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Locality / Full Address"
                          name="locality"
                          value={formData.locality}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="City"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="State"
                          name="state"
                          value={formData.state}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Pincode"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Country"
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-12">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Address Type (e.g., Home, Work)"
                          name="address_type"
                          value={formData.address_type}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        // Ensure required fields are filled before calling API
                        if (Object.values(formData).every(val => val.trim())) { 
                            handleAddAddress(formData); // Note: Assuming handleAddAddress takes raw formData
                            setShowModal(false);
                            setFormData({ // Optional: clear form data after submission
                                temp_name: "", temp_mobile: "", locality: "", pincode: "",
                                city: "", state: "", country: "", address_type: "",
                            });
                        } else {
                            toast.error("Please fill all address fields.");
                        }
                      }}
                    >
                      Save Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Order Summary Section */}
        <div className="col-lg-6 col-md-12 mb-4">
          <div className="card shadow-sm p-4 sticky-top" style={{ top: '100px' }}>
            <h3 className="mb-3">Order Summary</h3>
            {cartItems.map((item) => (
              <div
                key={item.id}
                className="d-flex justify-content-between align-items-start mb-2 border-bottom pb-2"
              >
                <div>
                  <h6 className="mb-0">{item.title}</h6>
                  <small className="text-muted d-block">
                    Size: {item.size || 'N/A'} | Print: {item.print || 'N/A'}
                  </small>
                  <small className="text-muted">
                    Qty: {item.quantity} x ₹{item.price}
                  </small>
                </div>
                <div>
                  <b>₹{item.quantity * item.price}</b>
                </div>
              </div>
            ))}
            <hr />
            <div className="d-flex justify-content-between mb-3">
              <h5>Total Payable:</h5>
              <h5 className="text-success">₹{totalPrice}</h5>
            </div>
            <button 
              className="btn btn-success w-100 py-2 fw-bold" 
              onClick={handleSubmitOrder}
              disabled={!selectAddress || cartItems.length === 0} // Disable if no address selected or cart is empty
            >
              Place Order (COD)
            </button>
            {!selectAddress && <p className="text-danger mt-2 text-center">Please select an address to place the order.</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;